import React from 'react';
import Header from '../../components/user/Header';

function NavbarOnly() {
  // Simple page that shows ONLY the navbar, no extra layout chrome
  return <Header />;
}

export default NavbarOnly;

